// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: FX7sJMOvuD

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Button from "../../Button"; // plasmic-import: MznF3tGFZjD/component

import { useScreenVariants as useScreenVariants_5VS0GwAl4 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: -5vS0GW_al4/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicHeader.module.css"; // plasmic-import: FX7sJMOvuD/css

import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: OZSfMt1ZAhb/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: QKCDMAfoLkN/icon
import resourcePalpngRhAsMNmq0BQo from "./images/resourcePalpng.png"; // plasmic-import: rhAsMNmq0bQo/picture

createPlasmicElementProxy;

export type PlasmicHeader__VariantMembers = {};
export type PlasmicHeader__VariantsArgs = {};
type VariantPropType = keyof PlasmicHeader__VariantsArgs;
export const PlasmicHeader__VariantProps = new Array<VariantPropType>();

export type PlasmicHeader__ArgsType = {};
type ArgPropType = keyof PlasmicHeader__ArgsType;
export const PlasmicHeader__ArgProps = new Array<ArgPropType>();

export type PlasmicHeader__OverridesType = {
  root?: p.Flex<"div">;
  container?: p.Flex<"div">;
  menu?: p.Flex<"div">;
  columns?: p.Flex<"div">;
  homeButton?: p.Flex<"button">;
  img?: p.Flex<typeof p.PlasmicImg>;
  column?: p.Flex<"div">;
  button?: p.Flex<typeof Button>;
  text?: p.Flex<"div">;
  shareYourProductButton?: p.Flex<"a">;
  h6?: p.Flex<"h6">;
};

export interface DefaultHeaderProps {
  className?: string;
}

const $$ = {};

function PlasmicHeader__RenderFunc(props: {
  variants: PlasmicHeader__VariantsArgs;
  args: PlasmicHeader__ArgsType;
  overrides: PlasmicHeader__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_5VS0GwAl4()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"container"}
        data-plasmic-override={overrides.container}
        className={classNames(projectcss.all, sty.container)}
      >
        <div
          data-plasmic-name={"menu"}
          data-plasmic-override={overrides.menu}
          className={classNames(projectcss.all, sty.menu)}
        >
          <div className={classNames(projectcss.all, sty.freeBox___2Ksq)}>
            <p.Stack
              as={"div"}
              data-plasmic-name={"columns"}
              data-plasmic-override={overrides.columns}
              hasGap={true}
              className={classNames(projectcss.all, sty.columns)}
            >
              <button
                data-plasmic-name={"homeButton"}
                data-plasmic-override={overrides.homeButton}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  sty.homeButton
                )}
                ref={ref => {
                  $refs["homeButton"] = ref;
                }}
              >
                <p.PlasmicImg
                  data-plasmic-name={"img"}
                  data-plasmic-override={overrides.img}
                  alt={""}
                  className={classNames(sty.img)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "70%"
                      : "70%"
                  }
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"lazy"}
                  src={{
                    src: resourcePalpngRhAsMNmq0BQo,
                    fullWidth: 6688,
                    fullHeight: 944,
                    aspectRatio: undefined
                  }}
                />
              </button>
              <div
                data-plasmic-name={"column"}
                data-plasmic-override={overrides.column}
                className={classNames(projectcss.all, sty.column)}
              >
                <Button
                  data-plasmic-name={"button"}
                  data-plasmic-override={overrides.button}
                  className={classNames("__wab_instance", sty.button)}
                  color={"blue"}
                >
                  <div
                    data-plasmic-name={"text"}
                    data-plasmic-override={overrides.text}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text
                    )}
                  >
                    {"Share your product with us!"}
                  </div>
                </Button>
                <div
                  className={classNames(projectcss.all, sty.freeBox___1SJcg)}
                >
                  <a
                    data-plasmic-name={"shareYourProductButton"}
                    data-plasmic-override={overrides.shareYourProductButton}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty.shareYourProductButton
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "mobileOnly") ? (
                      <React.Fragment>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <h6
                            data-plasmic-name={"h6"}
                            data-plasmic-override={overrides.h6}
                            className={classNames(
                              projectcss.all,
                              projectcss.h6,
                              projectcss.__wab_text,
                              sty.h6
                            )}
                          >
                            {hasVariant(
                              globalVariants,
                              "screen",
                              "mobileOnly"
                            ) ? (
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#54A0E0" }}
                                >
                                  {"Share your product with us!"}
                                </span>
                                <React.Fragment>{""}</React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#FF8700" }}
                                >
                                  {" "}
                                </span>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#54A0E0" }}
                                >
                                  {"Share your product with us!"}
                                </span>
                                <React.Fragment>{""}</React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#ACAAAA" }}
                                >
                                  {"  "}
                                </span>
                                <React.Fragment>{""}</React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#FF8700" }}
                                >
                                  {"          "}
                                </span>
                              </React.Fragment>
                            )}
                          </h6>
                        }
                        <React.Fragment>{""}</React.Fragment>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <h6
                            data-plasmic-name={"h6"}
                            data-plasmic-override={overrides.h6}
                            className={classNames(
                              projectcss.all,
                              projectcss.h6,
                              projectcss.__wab_text,
                              sty.h6
                            )}
                          >
                            {hasVariant(
                              globalVariants,
                              "screen",
                              "mobileOnly"
                            ) ? (
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#54A0E0" }}
                                >
                                  {"Share your product with us!"}
                                </span>
                                <React.Fragment>{""}</React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#FF8700" }}
                                >
                                  {" "}
                                </span>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#54A0E0" }}
                                >
                                  {"Share your product with us!"}
                                </span>
                                <React.Fragment>{""}</React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#ACAAAA" }}
                                >
                                  {"  "}
                                </span>
                                <React.Fragment>{""}</React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#FF8700" }}
                                >
                                  {"          "}
                                </span>
                              </React.Fragment>
                            )}
                          </h6>
                        }
                        <React.Fragment>{""}</React.Fragment>
                      </React.Fragment>
                    )}
                  </a>
                </div>
              </div>
            </p.Stack>
          </div>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "container",
    "menu",
    "columns",
    "homeButton",
    "img",
    "column",
    "button",
    "text",
    "shareYourProductButton",
    "h6"
  ],
  container: [
    "container",
    "menu",
    "columns",
    "homeButton",
    "img",
    "column",
    "button",
    "text",
    "shareYourProductButton",
    "h6"
  ],
  menu: [
    "menu",
    "columns",
    "homeButton",
    "img",
    "column",
    "button",
    "text",
    "shareYourProductButton",
    "h6"
  ],
  columns: [
    "columns",
    "homeButton",
    "img",
    "column",
    "button",
    "text",
    "shareYourProductButton",
    "h6"
  ],
  homeButton: ["homeButton", "img"],
  img: ["img"],
  column: ["column", "button", "text", "shareYourProductButton", "h6"],
  button: ["button", "text"],
  text: ["text"],
  shareYourProductButton: ["shareYourProductButton", "h6"],
  h6: ["h6"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  container: "div";
  menu: "div";
  columns: "div";
  homeButton: "button";
  img: typeof p.PlasmicImg;
  column: "div";
  button: typeof Button;
  text: "div";
  shareYourProductButton: "a";
  h6: "h6";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHeader__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHeader__VariantsArgs;
    args?: PlasmicHeader__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHeader__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicHeader__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicHeader__ArgProps,
          internalVariantPropNames: PlasmicHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHeader";
  } else {
    func.displayName = `PlasmicHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicHeader = Object.assign(
  // Top-level PlasmicHeader renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    container: makeNodeComponent("container"),
    menu: makeNodeComponent("menu"),
    columns: makeNodeComponent("columns"),
    homeButton: makeNodeComponent("homeButton"),
    img: makeNodeComponent("img"),
    column: makeNodeComponent("column"),
    button: makeNodeComponent("button"),
    text: makeNodeComponent("text"),
    shareYourProductButton: makeNodeComponent("shareYourProductButton"),
    h6: makeNodeComponent("h6"),

    // Metadata about props expected for PlasmicHeader
    internalVariantProps: PlasmicHeader__VariantProps,
    internalArgProps: PlasmicHeader__ArgProps
  }
);

export default PlasmicHeader;
/* prettier-ignore-end */
